import React from 'react';
import { Home } from './pages/Home';
import { LanguageProvider } from './context/LanguageContext';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="35bsf2xftp6t8">
      <Home data-id="element-1" data-mp="35eem8vysxkax" />
    </LanguageProvider>;
}